import { supabase } from './supabaseClient';
import { recruitmentAdminAuth } from './recruitmentAccess';
export const emptyRequisition = { job_title: '', department: '', job_description: '', openings: 1, status: 'open', hiring_manager_id: '' };
export const requisitionStatus = status => ({open:'Open',on_hold:'On hold',closed:'Closed'}[status] || status);
export async function requisitionAdmin(company, action, payload = {}, client = supabase) {
  if (action === 'save') {
    if (!String(payload.department || '').trim()) throw new Error('Department / team is required.');
    if (!String(payload.job_title || '').trim() || !String(payload.job_description || '').trim()) throw new Error('Job title and job description are required.');
    if (!Number.isInteger(Number(payload.openings)) || Number(payload.openings)<1 || Number(payload.openings)>1000) throw new Error('Openings must be a whole number from 1 to 1000.');
  }
  const { data, error } = await client.rpc('recruitment_requisition_admin', {
    ...recruitmentAdminAuth(company), p_action:action, p_payload:payload,
  });
  if (error) throw new Error(error.code==='PGRST202'||/function.*does not exist|schema cache/i.test(error.message||'')
    ? 'Job requisition setup is required. Run supabase/recruitment_requisitions_update.sql in Supabase SQL Editor, then refresh.' : error.message);
  if (action==='list' && !Array.isArray(data)) throw new Error('Could not load job requisitions. Please retry.');
  if (action==='save' && !data?.id) throw new Error('Could not confirm the saved requisition. Refresh before retrying.');
  return data;
}
